import React, { MutableRefObject, useState } from 'react';
import truncate from 'truncate-html';
import { Element } from 'react-scroll';
import { Box, Flex } from '@components/layout/Grid';
import { ProgramIntroductionStyles } from '@components/texts';
import ProgramCollapsibleTitle from '@components/ProgramCollapsibleTitle';
import PhaseProgramVideoCard from '@organisms/cards/ProgramVideoCard';
import { getVideoDescription } from '@lib/helpers';
import { GenericProgram } from '@gql/generated';
import { programTypes } from '@lib/constants';
import { Instructor, ProgramOutroFieldsFragment } from '@gql/generated';

type Props = {
  data: ProgramOutroFieldsFragment;
  genericProgram: GenericProgram;
  isOpen: boolean;
  onOpen(): void;
  onClose(): void;
  programLanguage: string;
  'data-testid'?: string;
};
const PhasedProgramOutroCollapsable = (props: Props) => {
  const {
    data,
    isOpen,
    onOpen,
    onClose,
    genericProgram,
    'data-testid': dataTestId,
  } = props;

  const [showMore] = useState(false);
  const truncatedContent = truncate(data.description, 100, {
    byWords: true,
  });

  const phaseSlug = 'outro';
  const weekSlug = data.slug;
  const programCategory =
    programTypes[genericProgram.category || 'program'].listingPageSlug;

  return (
    <ProgramCollapsibleTitle
      title={() => data.label}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      data-testid={dataTestId}
    >
      <Element name="outro">
        <Box px={20}>
          {showMore ? (
            <ProgramIntroductionStyles
              className="embeddedText"
              dangerouslySetInnerHTML={{
                __html: data.description,
              }}
            />
          ) : (
            <ProgramIntroductionStyles
              className="embeddedText"
              dangerouslySetInnerHTML={{
                __html: truncatedContent,
              }}
            />
          )}
          <Flex flexDirection="column" flexWrap="wrap" mt={30}>
            {data.videos.map(({ locked, video, slug }, i) => {
              return (
                <PhaseProgramVideoCard
                  key={i}
                  locked={locked}
                  redirectTo={`/${genericProgram.language}/${programCategory}/${genericProgram.slug}/${phaseSlug}/${weekSlug}/${slug}`}
                  video={{
                    id: video.id,
                    identifier: video.identifier,
                    title: video.title,
                    description: getVideoDescription(video),
                    thumbnailUrl: video.assets.thumbnailUrl,
                    kind: video.kind,
                    flavor: video.taxonomies?.flavor?.name,
                    publishedAt: video.meta?.publishedAt,
                    duration: video.meta.minutes,
                    cursorAt: video.cursorAt,
                    genreName: video.taxonomies?.genre?.name,
                    genreSlug: video.taxonomies?.genre?.slug,
                    // TODO: fix this type
                    instructors: video?.taxonomies?.instructors as Instructor[],
                  }}
                />
              );
            })}
          </Flex>
        </Box>
      </Element>
    </ProgramCollapsibleTitle>
  );
};

export default PhasedProgramOutroCollapsable;
